import axios from "axios";
export const baseUrl = "https://www.prova-energy.com.cn/GwSelectContent";
// axios.defaults.baseURL = "http://www.hrbhousedata.com/shrn-mobile";

axios.create({
  timeout: 3000,
});
axios.interceptors.request.use(
  (config) => {
    config.headers["Content-Type"] = "application/json;charset=UTF-8";
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (config) => {
    if (!!localStorage.getItem("userType")) {
      if (config.data.state === "403") {
        Message({
          showClose: true,
          message: config.data.msg,
          type: "warning",
          duration: 1000,
        });
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("userType");
        bus.$emit("UToken", "");
        router.replace({
          path: "/dl",
        });
      }
    }
    return config;
  },
  (error) => {
    if (error && error.response) {
      switch (error.response.status) {
        case 401:
          Message({
            showClose: true,
            message: "登陆超时，请重新登录",
            type: "warning",
            duration: 1000,
          });
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          localStorage.removeItem("userType");
          bus.$emit("UToken", "");
          router.replace({
            path: "/dl",
          });
          break;
        default:
          break;
      }
    }
    // return Promise.reject(error);
  }
);
